import React from 'react';
import { api } from "../utils/api";

const resendInvoice = async (idTransaction) => {
    // setLoading(true);
    const dataToSend = {
        idTransaction: idTransaction,
    };

    try {
        const response = await api("v1/transaction/sendTransactionInvoice", "POST", dataToSend);
        if (response.data.success) {
            alert("Invoice Email Sent")
        } else {
            alert(response.data.message);
        }
    } catch (error) {
        console.error("API error:", error);
    }
    // setLoading(false); //once api call is finished.
};

function InvoiceDetails({ invoiceDetail, idTransaction = null }) {
    const formatDate = (value) => {
        if (!value) return "N/A";
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? "N/A" : d.toLocaleDateString();
    };

    const amount = (value) => {
        if (value === null || value === undefined || value === "") return "0.00";
        const num = Number(value);
        return Number.isNaN(num) ? "0.00" : num.toFixed(2);
    };

    const lineItems = Array.isArray(invoiceDetail?.LineItems) ? invoiceDetail.LineItems : [];
    const contactAddresses = Array.isArray(invoiceDetail?.Contact?.Addresses) ? invoiceDetail.Contact.Addresses : [];
    const primaryAddress = contactAddresses[0] || {};

    return (invoiceDetail &&
        <div className='flex flex-column w-full gap-2'>
            <div className='flex flex-column border-2 p-2 rounded-md'>
                <strong>Invoice Details</strong>
                <p>Invoice Number: {invoiceDetail.InvoiceNumber}</p>
                <p>Status: {invoiceDetail.Status}</p>
                <p>Date: {formatDate(invoiceDetail.Date)}</p>
                <p>Due Date: {formatDate(invoiceDetail.DueDate)}</p>
                <p>Amount Due: ${amount(invoiceDetail.AmountDue)}</p>
                <p>Total: ${amount(invoiceDetail.Total)}</p>
            </div>
            <div className='flex flex-column border-2 p-2 rounded-md'>
                <strong>Contact Information</strong>
                <span>{invoiceDetail?.Contact?.Name || "N/A"}</span>
                <span>{invoiceDetail?.Contact?.EmailAddress || "N/A"}</span>
                <span>{primaryAddress?.City || 'City not set'}, {primaryAddress?.Region || 'Region not set'}, {primaryAddress?.Country || 'Country not set'}</span>
            </div>
            <div className='flex flex-column border-2 p-2 rounded-md'>
                <strong>Line Items</strong>
                {lineItems.map((item, index) => (
                    <div key={index}>
                        <p>Description: {item.Description}</p>
                        <p>Unit Amount: ${amount(item.UnitAmount)}</p>
                        <p>Quantity: {item.Quantity ?? 1}</p>
                        <p>Line Amount: ${amount(item.LineAmount)}</p>
                    </div>
                ))}
                {lineItems.length === 0 && <p>No line items available.</p>}
            </div>
            {/* {idTransaction && <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 rounded" onClick={() => resendInvoice(idTransaction)}>Resend Invoice</button>} */}
        </div>
    );
}

export default InvoiceDetails;
